/***************************************************************************
 * The contents of this file were generated with Amplify Studio.           *
 * Please refrain from making any modifications to this file.              *
 * Any changes to this file will be overwritten when running amplify pull. *
 **************************************************************************/

/* eslint-disable */
import * as React from "react";
import {
  Autocomplete,
  Badge,
  Button,
  Divider,
  Flex,
  Grid,
  Icon,
  ScrollView,
  Text,
  TextField,
  useTheme,
} from "@aws-amplify/ui-react";
import { fetchByPath, getOverrideProps, validateField } from "./utils";
import { generateClient } from "aws-amplify/api";
import { listTenants } from "../graphql/queries";
import { createClients, updateTenants } from "../graphql/mutations";
const client = generateClient();
function ArrayField({
  items = [],
  onChange,
  label,
  inputFieldRef,
  children,
  hasError,
  setFieldValue,
  currentFieldValue,
  defaultFieldValue,
  lengthLimit,
  getBadgeText,
  runValidationTasks,
  errorMessage,
}) {
  const labelElement = <Text>{label}</Text>;
  const {
    tokens: {
      components: {
        fieldmessages: { error: errorStyles },
      },
    },
  } = useTheme();
  const [selectedBadgeIndex, setSelectedBadgeIndex] = React.useState();
  const [isEditing, setIsEditing] = React.useState();
  React.useEffect(() => {
    if (isEditing) {
      inputFieldRef?.current?.focus();
    }
  }, [isEditing]);
  const removeItem = async (removeIndex) => {
    const newItems = items.filter((value, index) => index !== removeIndex);
    await onChange(newItems);
    setSelectedBadgeIndex(undefined);
  };
  const addItem = async () => {
    const { hasError } = runValidationTasks();
    if (
      currentFieldValue !== undefined &&
      currentFieldValue !== null &&
      currentFieldValue !== "" &&
      !hasError
    ) {
      const newItems = [...items];
      if (selectedBadgeIndex !== undefined) {
        newItems[selectedBadgeIndex] = currentFieldValue;
        setSelectedBadgeIndex(undefined);
      } else {
        newItems.push(currentFieldValue);
      }
      await onChange(newItems);
      setIsEditing(false);
    }
  };
  const arraySection = (
    <React.Fragment>
      {!!items?.length && (
        <ScrollView height="inherit" width="inherit" maxHeight={"7rem"}>
          {items.map((value, index) => {
            return (
              <Badge
                key={index}
                style={{
                  cursor: "pointer",
                  alignItems: "center",
                  marginRight: 3,
                  marginTop: 3,
                  backgroundColor:
                    index === selectedBadgeIndex ? "#B8CEF9" : "",
                }}
                onClick={() => {
                  setSelectedBadgeIndex(index);
                  setFieldValue(items[index]);
                  setIsEditing(true);
                }}
              >
                {getBadgeText ? getBadgeText(value) : value.toString()}
                <Icon
                  style={{
                    cursor: "pointer",
                    paddingLeft: 3,
                    width: 20,
                    height: 20,
                  }}
                  viewBox={{ width: 20, height: 20 }}
                  paths={[
                    {
                      d: "M10 10l5.09-5.09L10 10l5.09 5.09L10 10zm0 0L4.91 4.91 10 10l-5.09 5.09L10 10z",
                      stroke: "black",
                    },
                  ]}
                  ariaLabel="button"
                  onClick={(event) => {
                    event.stopPropagation();
                    removeItem(index);
                  }}
                />
              </Badge>
            );
          })}
        </ScrollView>
      )}
      <Divider orientation="horizontal" marginTop={5} />
    </React.Fragment>
  );
  if (lengthLimit !== undefined && items.length >= lengthLimit && !isEditing) {
    return (
      <React.Fragment>
        {labelElement}
        {arraySection}
      </React.Fragment>
    );
  }
  return (
    <React.Fragment>
      {labelElement}
      {isEditing && children}
      {!isEditing ? (
        <>
          <Button
            onClick={() => {
              setIsEditing(true);
            }}
          >
            Add item
          </Button>
          {errorMessage && hasError && (
            <Text color={errorStyles.color} fontSize={errorStyles.fontSize}>
              {errorMessage}
            </Text>
          )}
        </>
      ) : (
        <Flex justifyContent="flex-end">
          {(currentFieldValue || isEditing) && (
            <Button
              children="Cancel"
              type="button"
              size="small"
              onClick={() => {
                setFieldValue(defaultFieldValue);
                setIsEditing(false);
                setSelectedBadgeIndex(undefined);
              }}
            ></Button>
          )}
          <Button size="small" variation="link" onClick={addItem}>
            {selectedBadgeIndex !== undefined ? "Save" : "Add"}
          </Button>
        </Flex>
      )}
      {arraySection}
    </React.Fragment>
  );
}
export default function ClientsCreateForm(props) {
  const {
    clearOnSuccess = true,
    onSuccess,
    onError,
    onSubmit,
    onCancel,
    onValidate,
    onChange,
    overrides,
    ...rest
  } = props;
  const initialValues = {
    companycode: "",
    name: "",
    tenants: [],
  };
  const [companycode, setCompanycode] = React.useState(
    initialValues.companycode
  );
  const [name, setName] = React.useState(initialValues.name);
  const [tenants, setTenants] = React.useState(initialValues.tenants);
  const [tenantsLoading, setTenantsLoading] = React.useState(false);
  const [tenantsRecords, setTenantsRecords] = React.useState([]);
  const autocompleteLength = 10;
  const [errors, setErrors] = React.useState({});
  const resetStateValues = () => {
    setCompanycode(initialValues.companycode);
    setName(initialValues.name);
    setTenants(initialValues.tenants);
    setCurrentTenantsValue(undefined);
    setCurrentTenantsDisplayValue("");
    setErrors({});
  };
  const [currentTenantsDisplayValue, setCurrentTenantsDisplayValue] =
    React.useState("");
  const [currentTenantsValue, setCurrentTenantsValue] =
    React.useState(undefined);
  const tenantsRef = React.createRef();
  const getIDValue = {
    tenants: (r) => JSON.stringify({ id: r?.id }),
  };
  const tenantsIdSet = new Set(
    Array.isArray(tenants)
      ? tenants.map((r) => getIDValue.tenants?.(r))
      : getIDValue.tenants?.(tenants)
  );
  const getDisplayValue = {
    tenants: (r) => `${r?.subdomain ? r?.subdomain + " - " : ""}${r?.id}`,
  };
  const validations = {
    companycode: [{ type: "Required" }],
    name: [{ type: "Required" }],
    tenants: [],
  };
  const runValidationTasks = async (
    fieldName,
    currentValue,
    getDisplayValue
  ) => {
    const value =
      currentValue && getDisplayValue
        ? getDisplayValue(currentValue)
        : currentValue;
    let validationResponse = validateField(value, validations[fieldName]);
    const customValidator = fetchByPath(onValidate, fieldName);
    if (customValidator) {
      validationResponse = await customValidator(value, validationResponse);
    }
    setErrors((errors) => ({ ...errors, [fieldName]: validationResponse }));
    return validationResponse;
  };
  const fetchTenantsRecords = async (value) => {
    setTenantsLoading(true);
    const newOptions = [];
    let newNext = "";
    while (newOptions.length < autocompleteLength && newNext != null) {
      const variables = {
        limit: autocompleteLength * 5,
        filter: {
          or: [{ subdomain: { contains: value } }, { id: { contains: value } }],
        },
      };
      if (newNext) {
        variables["nextToken"] = newNext;
      }
      const result = (
        await client.graphql({
          query: listTenants.replaceAll("__typename", ""),
          variables,
        })
      )?.data?.listTenants?.items;
      var loaded = result.filter(
        (item) => !tenantsIdSet.has(getIDValue.tenants?.(item))
      );
      newOptions.push(...loaded);
      newNext = result.nextToken;
    }
    setTenantsRecords(newOptions.slice(0, autocompleteLength));
    setTenantsLoading(false);
  };
  React.useEffect(() => {
    fetchTenantsRecords("");
  }, []);
  return (
    <Grid
      as="form"
      rowGap="15px"
      columnGap="15px"
      padding="20px"
      onSubmit={async (event) => {
        event.preventDefault();
        let modelFields = {
          companycode,
          name,
          tenants,
        };
        const validationResponses = await Promise.all(
          Object.keys(validations).reduce((promises, fieldName) => {
            if (Array.isArray(modelFields[fieldName])) {
              promises.push(
                ...modelFields[fieldName].map((item) =>
                  runValidationTasks(
                    fieldName,
                    item,
                    getDisplayValue[fieldName]
                  )
                )
              );
              return promises;
            }
            promises.push(
              runValidationTasks(
                fieldName,
                modelFields[fieldName],
                getDisplayValue[fieldName]
              )
            );
            return promises;
          }, [])
        );
        if (validationResponses.some((r) => r.hasError)) {
          return;
        }
        if (onSubmit) {
          modelFields = onSubmit(modelFields);
        }
        try {
          Object.entries(modelFields).forEach(([key, value]) => {
            if (typeof value === "string" && value === "") {
              modelFields[key] = null;
            }
          });
          const modelFieldsToSave = {
            companycode: modelFields.companycode,
            name: modelFields.name,
          };
          const clients = (
            await client.graphql({
              query: createClients.replaceAll("__typename", ""),
              variables: {
                input: {
                  ...modelFieldsToSave,
                },
              },
            })
          )?.data?.createClients;
          const promises = [];
          promises.push(
            ...tenants.reduce((promises, original) => {
              promises.push(
                client.graphql({
                  query: updateTenants.replaceAll("__typename", ""),
                  variables: {
                    input: {
                      id: original.id,
                      clientsTenantsCompanycode: clients.companycode,
                    },
                  },
                })
              );
              return promises;
            }, [])
          );
          await Promise.all(promises);
          if (onSuccess) {
            onSuccess(modelFields);
          }
          if (clearOnSuccess) {
            resetStateValues();
          }
        } catch (err) {
          if (onError) {
            const messages = err.errors.map((e) => e.message).join("\n");
            onError(modelFields, messages);
          }
        }
      }}
      {...getOverrideProps(overrides, "ClientsCreateForm")}
      {...rest}
    >
      <TextField
        label="Companycode"
        isRequired={true}
        isReadOnly={false}
        value={companycode}
        onChange={(e) => {
          let { value } = e.target;
          if (onChange) {
            const modelFields = {
              companycode: value,
              name,
              tenants,
            };
            const result = onChange(modelFields);
            value = result?.companycode ?? value;
          }
          if (errors.companycode?.hasError) {
            runValidationTasks("companycode", value);
          }
          setCompanycode(value);
        }}
        onBlur={() => runValidationTasks("companycode", companycode)}
        errorMessage={errors.companycode?.errorMessage}
        hasError={errors.companycode?.hasError}
        {...getOverrideProps(overrides, "companycode")}
      ></TextField>
      <TextField
        label="Name"
        isRequired={true}
        isReadOnly={false}
        value={name}
        onChange={(e) => {
          let { value } = e.target;
          if (onChange) {
            const modelFields = {
              companycode,
              name: value,
              tenants,
            };
            const result = onChange(modelFields);
            value = result?.name ?? value;
          }
          if (errors.name?.hasError) {
            runValidationTasks("name", value);
          }
          setName(value);
        }}
        onBlur={() => runValidationTasks("name", name)}
        errorMessage={errors.name?.errorMessage}
        hasError={errors.name?.hasError}
        {...getOverrideProps(overrides, "name")}
      ></TextField>
      <ArrayField
        onChange={async (items) => {
          let values = items;
          if (onChange) {
            const modelFields = {
              companycode,
              name,
              tenants: values,
            };
            const result = onChange(modelFields);
            values = result?.tenants ?? values;
          }
          setTenants(values);
          setCurrentTenantsValue(undefined);
          setCurrentTenantsDisplayValue("");
        }}
        currentFieldValue={currentTenantsValue}
        label={"Tenants"}
        items={tenants}
        hasError={errors?.tenants?.hasError}
        runValidationTasks={async () =>
          await runValidationTasks("tenants", currentTenantsValue)
        }
        errorMessage={errors?.tenants?.errorMessage}
        getBadgeText={getDisplayValue.tenants}
        setFieldValue={(model) => {
          setCurrentTenantsDisplayValue(
            model ? getDisplayValue.tenants(model) : ""
          );
          setCurrentTenantsValue(model);
        }}
        inputFieldRef={tenantsRef}
        defaultFieldValue={""}
      >
        <Autocomplete
          label="Tenants"
          isRequired={false}
          isReadOnly={false}
          placeholder="Search Tenants"
          value={currentTenantsDisplayValue}
          options={tenantsRecords
            .filter((r) => !tenantsIdSet.has(getIDValue.tenants?.(r)))
            .map((r) => ({
              id: getIDValue.tenants?.(r),
              label: getDisplayValue.tenants?.(r),
            }))}
          isLoading={tenantsLoading}
          onSelect={({ id, label }) => {
            setCurrentTenantsValue(
              tenantsRecords.find((r) =>
                Object.entries(JSON.parse(id)).every(
                  ([key, value]) => r[key] === value
                )
              )
            );
            setCurrentTenantsDisplayValue(label);
            runValidationTasks("tenants", label);
          }}
          onClear={() => {
            setCurrentTenantsDisplayValue("");
          }}
          onChange={(e) => {
            let { value } = e.target;
            fetchTenantsRecords(value);
            if (errors.tenants?.hasError) {
              runValidationTasks("tenants", value);
            }
            setCurrentTenantsDisplayValue(value);
            setCurrentTenantsValue(undefined);
          }}
          onBlur={() =>
            runValidationTasks("tenants", currentTenantsDisplayValue)
          }
          errorMessage={errors.tenants?.errorMessage}
          hasError={errors.tenants?.hasError}
          ref={tenantsRef}
          labelHidden={true}
          {...getOverrideProps(overrides, "tenants")}
        ></Autocomplete>
      </ArrayField>
      <Flex
        justifyContent="space-between"
        {...getOverrideProps(overrides, "CTAFlex")}
      >
        <Button
          children="Clear"
          type="reset"
          onClick={(event) => {
            event.preventDefault();
            resetStateValues();
          }}
          {...getOverrideProps(overrides, "ClearButton")}
        ></Button>
        <Flex
          gap="15px"
          {...getOverrideProps(overrides, "RightAlignCTASubFlex")}
        >
          <Button
            children="Go Back"
            type="button"
            onClick={() => {
              onCancel && onCancel();
            }}
            {...getOverrideProps(overrides, "CancelButton")}
          ></Button>
          <Button
            children="Submit"
            type="submit"
            variation="primary"
            isDisabled={Object.values(errors).some((e) => e?.hasError)}
            {...getOverrideProps(overrides, "SubmitButton")}
          ></Button>
        </Flex>
      </Flex>
    </Grid>
  );
}
